// extracted by mini-css-extract-plugin
export var borderRadius = "_67-4";
export var large = "_67-3";
export var logoContainer = "_67-0";
export var nameLogo = "_67-2";
export var small = "_67-1";